import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { trackEvent, EVENTS } from "../utils/analytics";

export function HeroPromises() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 border border-brand-50/10 rounded-[2.5rem] bg-brand-50/[0.02] backdrop-blur-md overflow-hidden divide-y lg:divide-y-0 lg:divide-x divide-brand-50/10">
              {[
                {
                  title: "Choose where to invest",
                  body: "Pabs challenges assumptions, compares options and helps you decide where to invest your time and budget.",
                },
                {
                  title: "Get the experience right",
                  body: "Pabs gives your agents product and design direction, reviews their work and prepares focused corrections.",
                },
                {
                  title: "Follow through to results",
                  body: "Pabs connects decisions to delivered work, runs scheduled checks and uses new evidence to keep your strategy current.",
                },
              ].map((card, i) => (
                <div
                  key={i}
                  className="group p-10 hover:bg-brand-50/[0.04] transition-colors duration-500 text-left"
                >
                  <h3 className="text-2xl font-medium mb-4 text-brand-50">
                    {card.title}
                  </h3>
                  <p className="text-brand-400 leading-relaxed text-sm">
                    {card.body}
                  </p>
                </div>
              ))}
            </div>
  );
}

export default function HeroSection() {
  const handlePrimaryCTA = () => {
    trackEvent(EVENTS.CTA_CLICKED, { cta_id: "hero_start", section: "hero" });
    window.location.href = "/register";
  };

  return (
    <section className="relative min-h-screen overflow-hidden bg-brand-900 text-brand-50">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:80px_80px]"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-900/50 to-brand-900"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 pt-40 pb-24">
        <div className="max-w-6xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h1 className="text-5xl md:text-8xl lg:text-[100px] font-medium mb-10 leading-[0.95] text-brand-50">
              The product authority layer<br />for teams building with AI.
            </h1>

            <p className="text-xl md:text-2xl text-brand-400 mb-16 max-w-3xl mx-auto leading-relaxed font-light">
              Pabs performs the product management and design authority work that decides what
              gets built, gives agents clear boundaries, and reviews what they produce.
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center items-center mb-32">
              <button
                onClick={handlePrimaryCTA}
                className="h-16 px-10 bg-brand-50 text-brand-900 hover:bg-brand-200 transition-all duration-300 rounded-full font-bold shadow-2xl shadow-brand-50/10 text-lg flex items-center gap-2"
              >
                Get started free
                <ArrowRight className="ml-2 h-5 w-5" />
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="max-w-6xl mx-auto"
          >
            <HeroPromises/>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
